"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const with_editable_field_1 = require("./with-editable-field");
const Select = require("@atlaskit/select").default;
const { CreatableSelect } = require("@atlaskit/select");
exports.EditableSelect = with_editable_field_1.withEditableField(Select);
exports.EditableCreatableSelect = with_editable_field_1.withEditableField(CreatableSelect);
